<!-- 关于我们 -->
<template>

    <div class="joinbox">
        <div class="banxin">
             <div class="logobtns">
             <h1 class="logo"></h1> 
             <!-- <button class="regbtn"  @click="goRecharge()">Recharge</button>  -->
            </div>
             <h1>Become Agency</h1>
             <p>We always looking for Agent to join Mango Show! We are proud to show everyone’s talent and support them to be successful with an awesome dedicated team. If you have the desire to be a part of a agent in Mango Show, join us today!Don’t hesitate to send us email to :eveyin@mangolive.net</p>
    
        </div>
         <!-- <Footer></Footer> -->
    </div>  
</template>
<script>
export default {

    data(){
        return{
          isuser:true
        }
    },
     created(){

    },
    methods:{

    },
}
</script>
<style lang="less" scoped>

@media screen and (min-width: 900px) {
  .joinbox{
       background:#fff;
       font-size: .09rem;line-height:0.17rem
  }


    .logobtns{
      width: 100%; height: .42rem; display: flex; 
       box-sizing: border-box;
      justify-content: space-between; align-items: center;
     .logo{
         width:1.04rem; height: .2rem;
        background:  url('../../assets/images/liveimg/LOGO_phone@2x.png');
        background-size: 100% 100%;
     } 
  }
  h1{
    font-size:0.13rem; margin: .1rem 0 .08rem 0;
  }
}
@media screen and (max-width:899px){
  .joinbox{
       background:#fff;
       font-size: .3rem;line-height:0.45rem
  }
  .banxin{
    width: 80%;
  }


    .logobtns{
      width: 100%; height: .8rem; display: flex; 
       box-sizing: border-box;
      justify-content: space-between; align-items: center;
     .logo{
         width:3.46rem; height: .6rem;
        background:  url('../../assets/images/liveimg/LOGO_phone@2x.png');
        background-size: 100% 100%;
     } 
  }
    h1{
    font-size:0.4rem; margin: .5rem 0 .2rem 0;
  }
}

</style>


// WEBPACK FOOTER //
// src/page/webpage/becomeagency.vue